export interface ApplicationConfig {
  googleAnalytics: {
    config: string;
    debug_mode: boolean;
  };
  semantria: {
    url: string;
  };
  general: {
    loginMessage: string;
    loginIcon: string;
    kitchenResources: string;
  };
  maintenanceMode: {
    forceReadonly: boolean;
  };
  uploader: {
    maxFileSizeMB: number;
    maxFileSizeOverrides: {
      Excel: number;
    };
    allowedFileTypes: {
      [key: string]: string;
    };
    retry: {
      enableAuto: boolean;
      maxAutoAttempts: number;
    };
  };
  limits: {
    requeueRateMinutes: number;
    widgetMaxConcurrent: number;
    dateInterval: {
      [key: string]: {
        limit_minutes: number;
        fallback: string;
        drilldown: string;
      };
    };
  };
  rtrelay: {
    url: string;
    context: string;
    suppressErrors?: boolean;
  };
  blender: {
    url: string;
    audioUrl: string;
    telemetry: {
      endpoint: string;
      enabled: boolean;
    };
  };
  spote: {
    queryTopicPurposeGenerationScenarioId: string;
    userReviewGenerationQueryMatchScenarioId: string;
    userReviewGenerationScenarioId: string;
    rephraseUserReviewGenerationScenarioId: string;
    smartSummaryByDriverFieldSceneId: string;
    smartSummaryByAnalyticItemSceneId: string;
  };
}

export interface ApplicationVolatile {
  redirectTo: string;
  account_id: string;
}

declare global {
  const appConfig: ApplicationConfig;
  const appVolatile: ApplicationVolatile;
  const appVersion: string;
}

export function mergeConfigs(target: object, ...sources: object[]): ApplicationConfig {
  function isObject(item) {
    return item !== null && typeof item === 'object';
  }

  function isMergeable(item) {
    return isObject(item) && !Array.isArray(item);
  }

  if (!sources.length) {
    return target as ApplicationConfig;
  }
  const source = sources.shift();
  if (source === undefined) {
    return target as ApplicationConfig;
  }

  if (isMergeable(target) && isMergeable(source)) {
    Object.keys(source).forEach(function (key: string) {
      if (isMergeable(source[key])) {
        if (!target[key]) {
          target[key] = {};
        }
        mergeConfigs(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }

  return mergeConfigs(target, ...sources);
}
